<script lang="ts">
  import { _, locale } from 'svelte-i18n';
  import { browser } from '$app/environment';
  import { page } from '$app/state';
  import ThemeToggle from '$lib/components/ThemeToggle.svelte';
  import { Button } from '$lib/components/ui/button/index.js';
  import SlidersHorizontal from '@lucide/svelte/icons/sliders-horizontal';
  import X from '@lucide/svelte/icons/x';

  let { panelTopClass = 'top-11' } = $props<{ panelTopClass?: string }>();

  let isOpen = $state(false);
  let containerEl = $state<HTMLElement | null>(null);

  function changeLanguage(lang: string) {
    if (browser) {
      localStorage.setItem('language', lang);
      locale.set(lang);
    }
  }

  function togglePreferences() {
    isOpen = !isOpen;
  }

  function closePreferences() {
    isOpen = false;
  }

  function handleWindowPointerDown(event: PointerEvent) {
    if (!isOpen || !containerEl) return;
    const target = event.target as Node | null;
    if (!target) return;
    if (!containerEl.contains(target)) {
      closePreferences();
    }
  }

  function handleWindowKeyDown(event: KeyboardEvent) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      closePreferences();
    }
  }

  $effect(() => {
    page.url.pathname;
    isOpen = false;
  });
</script>

<svelte:window onpointerdown={handleWindowPointerDown} onkeydown={handleWindowKeyDown} />

<div class="relative" bind:this={containerEl}>
  <Button
    type="button"
    variant="outline"
    size="sm"
    onclick={togglePreferences}
    aria-label={$_('settings.preferences')}
    aria-expanded={isOpen}
  >
    <SlidersHorizontal class="h-4 w-4" />
    <span class="hidden sm:inline">{$_('settings.preferences')}</span>
  </Button>

  {#if isOpen}
    <div class={`absolute right-0 z-40 w-72 rounded-lg border border-border bg-popover p-3 text-popover-foreground shadow-lg ${panelTopClass}`}>
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-sm font-semibold">{$_('settings.preferences')}</h3>
        <Button type="button" variant="ghost" size="icon" class="h-8 w-8" onclick={closePreferences} aria-label={$_('common.close')} title={$_('common.close')}>
          <X class="h-4 w-4" />
        </Button>
      </div>
      <p class="mb-2 text-xs text-muted-foreground">{$_('settings.language')}</p>
      <div class="mb-3 grid grid-cols-2 gap-2">
        <Button type="button" variant="outline" size="sm" onclick={() => changeLanguage('no')}>{$_('languages.no')}</Button>
        <Button type="button" variant="outline" size="sm" onclick={() => changeLanguage('sv')}>{$_('languages.sv')}</Button>
        <Button type="button" variant="outline" size="sm" onclick={() => changeLanguage('da')}>{$_('languages.da')}</Button>
        <Button type="button" variant="outline" size="sm" onclick={() => changeLanguage('en')}>{$_('languages.en')}</Button>
      </div>
      <p class="mb-2 text-xs text-muted-foreground">{$_('settings.theme')}</p>
      <ThemeToggle showLabel={true} />
    </div>
  {/if}
</div>
